import { useState } from "react"

import { Button, Dialog, DialogTrigger } from "@coval/ui"

import type {
  SimulationWrapperChangeHandler,
  SimulationWrapperConfig,
} from "../types"
import { ApiSetupDialog } from "./ApiSetupDialog"

export function ApiBulkSetupButton({
  config,
  onChange,
  disabled = false,
  onDraftOpen,
}: {
  config: SimulationWrapperConfig | null | undefined
  onChange: SimulationWrapperChangeHandler<SimulationWrapperConfig>
  disabled?: boolean
  onDraftOpen?: () => () => void
}) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button type="button" variant="secondary" disabled={disabled}>
          API Setup for All Test Cases
        </Button>
      </DialogTrigger>
      {isOpen && (
        <ApiSetupDialog
          scope="test-set"
          config={config ?? {}}
          disabled={disabled}
          onDraftOpen={onDraftOpen}
          onCancel={() => setIsOpen(false)}
          onApply={(updated) => {
            if (onChange(updated) !== false) {
              setIsOpen(false)
            }
          }}
        />
      )}
    </Dialog>
  )
}
